import React from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { IncomeExpenseForm } from "../shared/IncomeExpenseForm";
import { fullRecalculation } from "../shared/FinancialViewHelpers";
import Error from "../../../shared/Error";

class AddIncomeExpenseModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: "",
      transaction_expense_type_id: "",
      value: "",
      percentage: true,
      type: "expense",
      position: "",
      isNotValid: false,
      errMsg: "",
      subKey: `x${new Date().getTime()}`,
    };
  }

  saveData = () => {
    const { listingData, setFinancial, setIsOpenNewIncomeModal } = this.props;
    const { value, percentage, type } = this.state;
    const nonDeletedAdditionals = listingData.transaction_income.additionalIncome.filter(
      // eslint-disable-next-line no-underscore-dangle
      (additional) => additional._destroy !== "1",
    );
    this.state.position = nonDeletedAdditionals.length + 1;
    if (type === "expense") {
      if (!percentage) {
        this.state.expense_amount = value;
      }
      listingData.transaction_income.custom_transaction_expenses_attributes.push(this.state);
    }
    if (type === "revenue") {
      if (!percentage) {
        this.state.revenue_amount = value;
      }
      listingData.transaction_income.custom_transaction_revenues_attributes.push(this.state);
    }
    listingData.transaction_income.additionalIncome.push(this.state);
    fullRecalculation(listingData, setFinancial);
    setIsOpenNewIncomeModal(false);
  };

  saveExpenseData = () => {
    const { name, value, percentage } = this.state;
    if (name && value) {
      if (percentage) {
        if (value >= 0 && value <= 100) {
          this.saveData();
        } else {
          this.setState({
            errMsg: "Value must be between 0 and 100.",
            isNotValid: true,
          });
        }
      } else {
        this.saveData();
      }
    } else {
      this.setState({
        errMsg: "Enter a name and value",
        isNotValid: true,
      });
    }
  };

  render() {
    const { setIsOpenNewIncomeModal, isOpenNewIncomeModal, listingData } = this.props;
    const { isNotValid, errMsg } = this.state;

    return (
      <Modal
        show={isOpenNewIncomeModal}
        onHide={() => setIsOpenNewIncomeModal(false)}
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
      >
        <Modal.Header
          description="This is unique to this transaction and will not be repeated"
          title="New Income Or Expense"
          closeButton
        />

        <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
          {isNotValid && <Error errorMessage={errMsg} />}

          <IncomeExpenseForm
            addIncome
            modalThis={this}
            expList={listingData.transaction_expense_types}
            expenseType="transaction"
            setIsOpenNewIncomeModal={setIsOpenNewIncomeModal}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

AddIncomeExpenseModal.propTypes = {
  isOpenNewIncomeModal: PropTypes.bool.isRequired,
  setIsOpenNewIncomeModal: PropTypes.func.isRequired,
  listingData: PropTypes.shape().isRequired,
  setFinancial: PropTypes.func.isRequired,
};

export default AddIncomeExpenseModal;
